import _ from 'lodash';
import React from 'react';
import useStableCallback from './useStableCallback';

export function useAsyncResource(callback, deps) {
  const [state, setState] = React.useState({
    token: _.uniqueId(),
    resource: undefined,
    error: undefined,
    loading: false,
    count: 0,
  });
  const refresh = useStableCallback(async () => {
    const token = _.uniqueId();
    setState((v) => ({ ...v, token, loading: true }));
    try {
      const resource = await callback();
      setState((v) => (v.token === token ? ({
        ...v, loading: false, resource, error: undefined, count: v.count + 1,
      }) : v));
    } catch (error) {
      setState((v) => (v.token === token ? ({
        ...v, loading: false, resource: undefined, error, count: v.count + 1,
      }) : v));
    }
  });
  React.useEffect(() => { refresh(); }, deps ?? []);
  return React.useMemo(() => ({
    ...state,
    refresh,
  }), [state]);
}

export default useAsyncResource;
